/* eslint-disable */
import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import ExpandableListIllustration from '../../components/ExpandableListIllustration';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import SafeBrowsing from '../../components/SafeBrowsing';
import eliIllustration from '../../../../../../assets/student-training/AIns/img1.png';
import step1 from '../../../../../../assets/student-training/AIns/step1.png';
import step2 from '../../../../../../assets/student-training/AIns/step2.png';
import step3 from '../../../../../../assets/student-training/AIns/step3.png';
import step4 from '../../../../../../assets/student-training/AIns/step4.png';
import { HCG_ICONS } from './iconMap';

const stepIconMap: Record<number, string> = {
  1: step1,
  2: step2,
  3: step3,
  4: step4,
};

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );

  const section2Items =
    paragraphsSettings?.section2Items?.map((item: any, index: number) => ({
      title: item.title,
      content: item.content,
      icon: HCG_ICONS[index](false),
    })) ?? [];

  const handleExpandableComplete = useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-AIns-section1-1'
    );
  }, [updateComponentState, p_course, p_topic]);

  return (
    <div className="topic-section-1">
      <ExpandableListIllustration
        mainTitle={paragraphsSettings.title}
        subTitle={paragraphsSettings.section1Title}
        description={paragraphsSettings.section1Desc}
        illustration={<img src={eliIllustration} alt="" />}
        items={paragraphsSettings.section1Items}
        id="student-training-AIns-section1-1"
        onComplete={handleExpandableComplete}
      />

      <div style={{ margin: '8rem 0' }}>
        <HighlightedCardsGrid
          subTitle={paragraphsSettings.section2Title}
          description={paragraphsSettings.section2Desc}
          items={section2Items}
        />
      </div>

      <SafeBrowsing
        title={paragraphsSettings.section3Title}
        slides={paragraphsSettings.section3Items}
        icons={stepIconMap}
      />
    </div>
  );
};

export default Section1;
